import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import OrderAggregatorsHeader from '../components/Header';
import FixedArea from '../components/FixedArea';
import Orders from './components/Orders';
import Customer from './components/Customer';
import Payment from './components/Payment';
import Delivery from './components/Delivery';
import Agreement from './components/Agreement';
import { Form } from 'react-final-form';
import moment from 'moment-timezone';
import i18n from 'i18n';
import SessionManager from 'util/session-manager';
import arrayMutators from 'final-form-arrays';
import { isEqual, cloneDeep } from 'lodash';
import ConfirmDialog from '../components/ConfirmDialog';
import PaymentType from 'constants/payment-type';
import Layer from './components/Layer';
import Colors from 'constants/colors';
import { css } from 'styled-components';
import ValidityPeriodMaxMonth from 'constants/validity-period-max-month';
import DeliveryPreferredDuration from 'constants/delivery-preferred-duration';
import NonAlertPaymentErrorCodes from 'constants/non-alert-payment-error-codes';
import MessageCardType from 'constants/message-card-type';

class Confirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      ordersInEdit: []
    };
    this.tempOrder = [];
    this.confirmDialog = React.createRef();
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.replace('/gift/#/');
      }
    });
  }

  async componentDidMount() {
    this.data = this.restoreData();

    if (this.data) {
      const { expiration, defaultDay } = this.data.masterData.vouchers[0];

      this.duration = moment.duration(expiration);
      this.datepickerMin = moment()
        .startOf('day')
        .add(moment.duration(defaultDay));
      this.datepickerMax = this.datepickerMin
        .clone()
        .add(ValidityPeriodMaxMonth, 'month');
      this.deliveryDatepickerMin = moment()
        .startOf('day')
        .add(moment.duration(this.data.masterData.delivery.defaultDay));
      this.deliveryDatepickerMax = this.deliveryDatepickerMin
        .clone()
        .add(DeliveryPreferredDuration);

      if (this.data.payment.type === PaymentType.card) {
        let completionData = SessionManager.loadCompletionData();
        if (completionData != null) {
          let {
            showAlert,
          } = this.props;
          const res = await this.props.getOrderAggregatorsError(completionData.userId);
          if (res != null && res.payload.data.errorCode != null && res.payload.data.errorMessage != null) {
            // エラーコードはerrorMessageに内包されているためそちらのみを使う
            showAlert(res.payload.data.errorMessage);
          }
          // エラー発生時カード番号は入力し直しになるため、クリアしておく。
          this.data.payment.maskedCardNo = '';
        }
      }

      this.setState({
        loaded: true
      });
    }
  }

  addOrder = push => {
    push('orders', this.orderTemplate);
  };

  restoreData = () => {
    let savedData;
    try {
      savedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }

    return savedData;
  };

  async handleSubmit(values) {
    const data = this.formatOrderAggregators(values);

    try {
      values.payment.type === PaymentType.card
        ? await this.props.postOrderAggregators(data)
        : await this.props.postOrderAggregatorsBankTransfer(data);
    } catch (error) {
      if (this.props.error) {
        const {
          showAlert,
          error: {
            data: { message }
          }
        } = this.props;
        if (NonAlertPaymentErrorCodes.some(code => message.includes(code))) {
          return;
        }
        return showAlert(message);
      }
    }

    SessionManager.saveCompletionDataLogic(this.props.identification);

    if (values.payment.type === PaymentType.card) {
      window.location.href = this.props.identification.redirectUrl;
      return;
    }

    return this.props.push('/order-aggregators/completion');
  }

  formatOrderAggregators(values) {
    const {
      customer,
      orders,
      payment: { type, creditToken, payerName },
      deliveries: { deliveryPreferred, preferredDate, preferredTime }
    } = values;

    delete customer.copyShipperValue;

    const deliveryVouchers = [];
    orders.forEach((order, id) => {
      if (order.referringOrderInfo.checked) return;

      const shipper = cloneDeep(order.shipper);
      delete shipper.copyShipperValue;

      deliveryVouchers.push({
        id,
        ...order.receiver,
        ...shipper
      });
    });

    const envelops = orders.map((order, id) => {
      const {
        wrappingInfo: {
          wrappingType,
          inscription: inscriptionArray,
          inscriptionType,
          shipperName: shipperNameArray,
          messageCard
        },
        purchaseItem: { expiredOn, validatedOn, num },
        referringOrderInfo
      } = order;

      let [inscription, shipperName] = ['', ''];
      if (
        wrappingType !==
        i18n.t('orderAggregators:common:order.wrappingType1Name')
      ) {
        inscription = isNaN(+inscriptionType)
          ? inscriptionType
          : inscriptionArray.join('<delimiter>');
        shipperName = shipperNameArray.join('<delimiter>');
      }

      const purchaseItems = [
        {
          num,
          expiredOn: moment
            .tz(expiredOn, i18n.t('common:dateFormat.default'), 'Asia/Tokyo')
            .utc()
            .format(),
          validatedOn: moment
            .tz(validatedOn, i18n.t('common:dateFormat.default'), 'Asia/Tokyo')
            .utc()
            .format()
        }
      ];

      const deliveries = {
        isWished: !!+deliveryPreferred,
        scheduledOn: !!+deliveryPreferred
          ? moment
              .tz(
                `${preferredDate}:${preferredTime}`,
                `${i18n.t('common:dateFormat.default')}:HH`,
                'Asia/Tokyo'
              )
              .utc()
              .format()
          : ''
      };

      const deliveryVoucherId = referringOrderInfo.checked
        ? +referringOrderInfo.targetIndex
        : id;

      // メッセージカードなしの場合は「入力」と同じメッセージカードタイプとする。
      const messageCardType =
        order.wrappingInfo.messageCardType === MessageCardType.none
          ? +MessageCardType.input
          : +order.wrappingInfo.messageCardType;

      return {
        deliveryVoucherId,
        wrappingType,
        messageCardType,
        messageCard,
        inscription,
        shipperName,
        purchaseItems,
        deliveries
      };
    });

    const payment = type === PaymentType.card ? { creditToken } : { payerName };

    return {
      customer,
      deliveryVouchers,
      envelops,
      payment
    };
  }

  handleClickEditOrder(form, index) {
    const ordersInEdit = [...this.state.ordersInEdit];
    ordersInEdit[index] = true;

    this.setState({
      ordersInEdit
    });

    this.tempOrder[index] = form.getState().values.orders[index];
  }

  handleClickCompleteEdit(index) {
    const ordersInEdit = [...this.state.ordersInEdit];
    ordersInEdit[index] = false;

    this.setState({
      ordersInEdit
    });
  }

  handleClickCancel(form, index) {
    if (isEqual(this.tempOrder[index], form.getState().values.orders[index])) {
      this.cancelEditOrder(form, index);
    } else {
      this.confirmDialog.current.open(index);
    }
  }

  cancelEditOrder(form, index) {
    form.change(`orders[${index}]`, this.tempOrder[index]);
    this.handleClickCompleteEdit(index);
  }

  getCost(orders) {
    const {
      data: { masterData, cost }
    } = this;

    if (orders == null) {
      return cost;
    }

    return {
      giftCard: {
        price: masterData.vouchers[0].price,
        count: orders.value.reduce(
          (result, order) => result + +order.purchaseItem.num,
          0
        )
      },
      shippingCost: {
        price: masterData.delivery.price,
        count: orders.value.filter(order => !order.referringOrderInfo.checked)
          .length
      }
    };
  }

  renderContents = form => (
    <React.Fragment>
      <Customer form={form} />
      <hr />
      <Payment
        form={form}
        showAlert={this.props.showAlert}
        closeAlert={this.props.closeAlert}
      />
      <hr />
      <Delivery
        form={form}
        datepickerMin={this.deliveryDatepickerMin}
        datepickerMax={this.deliveryDatepickerMax}
      />
      <hr />
    </React.Fragment>
  );

  render() {
    const {
      className,
      match: { path },
      fetchAddress
    } = this.props;

    if (!this.state.loaded) {
      return null;
    }

    const { orders, customer, payment, deliveries } = this.data;

    return (
      <div className={className}>
        <OrderAggregatorsHeader path={path} />
        <div className="order-aggregators-container">
          <Form
            onSubmit={value => this.handleSubmit(value)}
            mutators={{
              ...arrayMutators
            }}
            initialValues={{
              orders,
              customer,
              payment,
              deliveries
            }}
            render={({
              handleSubmit,
              submitting,
              form,
              hasValidationErrors
            }) => (
              <form onSubmit={value => handleSubmit(value)}>
                <div className="order-aggregators-content">
                  {this.state.ordersInEdit.some(v => !!v) ? (
                    <Layer children={this.renderContents(form)} />
                  ) : (
                    this.renderContents(form)
                  )}
                  <Orders
                    datepickerMin={this.datepickerMin}
                    datepickerMax={this.datepickerMax}
                    fetchAddress={fetchAddress}
                    duration={this.duration}
                    form={form}
                    onClickEdit={index =>
                      this.handleClickEditOrder(form, index)
                    }
                    onClickComplete={index =>
                      this.handleClickCompleteEdit(index)
                    }
                    onClickCancel={index => this.handleClickCancel(form, index)}
                    inEdit={this.state.ordersInEdit}
                  />
                  {this.state.ordersInEdit.some(v => !!v) ? (
                    <Layer children={<Agreement form={form} />} />
                  ) : (
                    <Agreement form={form} />
                  )}
                </div>

                <FixedArea
                  buttonText={i18n.t('orderAggregators:confirmation:submit')}
                  cost={this.getCost(form.getFieldState('orders'))}
                  disabled={hasValidationErrors || submitting}
                />

                <ConfirmDialog
                  innerRef={this.confirmDialog}
                  title={i18n.t(
                    'orderAggregators:common:order.alertCancelEditTitle'
                  )}
                  message={i18n.t(
                    'orderAggregators:common:order.alertCancelEdit'
                  )}
                  onSubmit={index => this.cancelEditOrder(form, index)}
                />
              </form>
            )}
          />
        </div>
      </div>
    );
  }
}

const commonStyle = css`
  hr {
    width: 100%;
    border: 0;
    border-top: 1px solid ${Colors.gray2};
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .order-aggregators-container {
    max-width: 1366px;
    padding: 72px 80px 160px;
    margin: 0 auto;
  }

  form {
    display: flex;
  }

  .order-aggregators-content {
    max-width: 762px;
    margin-top: -72px;
    margin-right: 136px;
  }

  hr {
    margin: 72px 0;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .order-aggregators-container {
    padding: 0 16px;
  }

  ${FixedArea} {
    margin: 0 -16px;
  }

  hr {
    margin: 32px 0;
  }
`;

export default applyStyles(Confirmation)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/index.js